import script from "./LLMChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./LLMChat.vue?vue&type=script&setup=true&lang=ts"

import "./LLMChat.vue?vue&type=style&index=0&id=6ec57184&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec57184"]])

export default __exports__